import template from './runExport.html';
import controller from './runExport.controller';

let runExportComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default runExportComponent;



// WEBPACK FOOTER //
// ./app/components/runExport/runExport.component.js